import { css } from "../../../../../../styled-system/css";

export const styles = {
  sectionWrapper: () =>
    css({
      flex: 1,
    }),
};
